import { ThemeButtons } from "./buttons";
import { ThemeColors } from "./colors";
import { Fonts, FontWeight, HeadingRegularVariants, LineHeights, radii, Shadows, TextVariants, zIndices } from "./enums";
import { ThemeForms } from "./forms";
import { ThemeImages } from "./images";
import { formBlock, formButtonSingleContainer, overlay } from "./layouts";
import { ThemeLinks } from "./links";
import { spaces } from "./spaces";
import { ThemeTextScale, ThemeTextStyles } from "./textStyles";
export const defaultTheme = {
    useRootStyles: true,
    useCustomProperties: true,
    breakpoints: ["30em", "40em", "54em", "90em", "125em"],
    zIndices: {
        [zIndices.notification]: 14,
        [zIndices.search]: 11,
        [zIndices.modal]: 11,
        [zIndices.overlay]: 13,
        [zIndices.megaMenu]: 10,
        [zIndices.stickyBars]: 10,
        [zIndices.stickyBarOverlay]: 9,
        [zIndices.inPage]: 8,
        [zIndices.page]: 2,
        [zIndices.trayMenu]: 1
    },
    radii: {
        [radii.clickable]: 3,
        [radii.pills]: 100
    },
    fontSizes: ThemeTextScale,
    colors: ThemeColors,
    space: spaces,
    sizes: spaces,
    fonts: {
        [Fonts.text]: "ultramarine_text, sans-serif",
        [Fonts.display]: "ultramarine_display, sans-serif"
    },
    fontWeights: {
        [FontWeight.textBold]: 800,
        [FontWeight.textRegular]: 400,
        [FontWeight.displayRegular]: 400,
        [FontWeight.displayBold]: 800
    },
    lineHeights: {
        [LineHeights.editorial]: 1.6,
        [LineHeights.heading]: 1.2,
        [LineHeights.label]: 1.2,
        [LineHeights.largeHeadings]: 1
    },
    shadows: {
        [Shadows.small]: "0px 4px 4px rgba(34, 34, 34, 0.15)",
        [Shadows.large]: "0 0 24px rgba(0, 0, 0, .125)"
    },
    styles: {
        root: {
            fontFamily: [Fonts.text],
            fontWeight: [FontWeight.textRegular],
            lineHeight: [LineHeights.editorial]
        },
        p: {
            variant: `text.${TextVariants.technicalParagraphSmall}`
        },
        h1: {
            fontWeight: FontWeight.displayRegular,
            variant: `text.${HeadingRegularVariants.first}`
        },
        h2: {
            fontWeight: FontWeight.displayRegular,
            variant: `text.${HeadingRegularVariants.first}`
        },
        h3: {
            fontWeight: FontWeight.displayRegular,
            variant: `text.${HeadingRegularVariants.third}`
        },
        h4: {
            fontWeight: FontWeight.displayRegular,
            variant: `text.${HeadingRegularVariants.fourth}`
        },
        h5: {
            fontWeight: FontWeight.displayRegular,
            variant: `text.${HeadingRegularVariants.fifth}`
        },
        h6: {
            fontWeight: FontWeight.displayRegular,
            variant: `text.${HeadingRegularVariants.sixth}`
        },
        a: {
            m: "inherit"
        }
    },
    text: ThemeTextStyles,
    links: ThemeLinks,
    buttons: ThemeButtons,
    forms: ThemeForms,
    images: ThemeImages,
    layout: {
        container: {
            margin: 0
        },
        overlay: overlay,
        formBlock: formBlock,
        formBlockSingleContainer: formButtonSingleContainer
    }
};
export default defaultTheme;
//# sourceMappingURL=theme.js.map